import React from "react";
import { Typography, Avatar, Badge, Popover, Divider } from "@mui/material";
import en from "../../../nls/en.json";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { readNotifications } from "../../../store/studentSlice";
import { getInitial, isEmpty } from "../../../utils/constants";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

const NotificationPopUp = ({
  notificationPopup,
  setNoficationPopup,
  notifications,
  notificationCount
}) => {
  const dispatch = useDispatch();
  const count = notificationCount?.unreadedCount;

  const handleNotification = () => {
    dispatch(readNotifications());
    setNoficationPopup(!notificationPopup);
  };
  return (
    <Badge
      badgeContent={count}
      color="primary"
      onClick={handleNotification}
      sx={{mr:1.4}}
    >
      <NotificationsNoneOutlinedIcon sx={{ color: "#1468A2" }} />
        <Popover
          open={notificationPopup}
          onClose={() => setNoficationPopup(false)}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        PaperProps={{ sx: { width: 460, height: !isEmpty(notifications?.result) ? 'auto' : 100, marginTop:5 } }}
        >
          <Typography
            sx={{ p: 1.4, backgroundColor: "#1468a2", color: "#fff" }}
            id="modal-modal-description"
            variant="h5"
            component="h2"
          >
            {en.NOTIFICATIONS}
          </Typography>

          {!isEmpty(notifications?.result) ? notifications?.result?.map((data) => (
          <div key={data?.id}>
              <Typography
                sx={{ pl: 2, pt: 1.4, fontWeight: 600, display: "flex" }}
                component="h2"
              >
                <Avatar sx={{backgroundColor:"#44A4EB"}}>
                 {!isEmpty(data?.name) ? getInitial(data?.name, true) : null}
               </Avatar>
                <span style={{ padding: 8 }}>
                {!isEmpty(data?.name) ? data?.name : null}
                </span>
              </Typography>
              <Typography
              sx={{
                p: 2,
                pt: 0.6,
                display: "inline-flex",
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              component="h2"
            >
              {data?.notification}
            </Typography>
               <Divider sx={{ color: "#fff" }} />
          </div>
          )) :
              <Typography
              sx={{
                p: 2,
                pt: 0.6,
                display: "inline-flex",
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              component="h2"
            >
             {en.NO_NOTIFICATION}
            </Typography>
        }
      </Popover>
  </Badge>
  );
};

export default NotificationPopUp;

NotificationPopUp.propTypes = {
  notificationPopup: PropTypes.bool.isRequired,
  notificationCount: PropTypes.object.isRequired,
  notifications: PropTypes.object.isRequired,
  setNoficationPopup: PropTypes.any.isRequired,
};
